import styled from '@emotion/styled'

export const TimerValueRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  && {
    > * {
      margin-right: 8px;
    }
  }
`
